/**
 * RouteServiceProvider
 *
 * 路由服务 Context Provider，将 IRouteService 注入到 React 组件树中。
 *
 * client-runtime-mod 应该在应用根节点使用此 Provider，
 * 使所有子组件可以通过 useRoute() hook 获取路由服务。
 */
import * as React from 'react';
import { RouteServiceContext } from './route-context.js';
/**
 * 路由服务 Provider
 */
export function RouteServiceProvider({ routeService, children }) {
    return React.createElement(RouteServiceContext.Provider, { value: routeService }, children);
}
//# sourceMappingURL=route-service-provider.js.map